<template>
  <div v-if="isLoading">
    <base-spinner></base-spinner>
  </div>
  <div class="table" v-else>
    <div class="table-header">
      <p>Subscription</p>
      <div>
        <input v-model="filterTerm" placeholder="Tên người đăng ký" @keyup.enter="sendFilterTerm"/>
        <button style="background-color: #0298cf; border-radius: 0px; border-top-right-radius: 6px; border-bottom-right-radius: 6px; height: 40px; margin-right: 15px"
          @click.prevent="sendFilterTerm"><i class="fa-solid fa-magnifying-glass"></i></button>

        <button @click="exportExcel" class="excel-btn" :class="{ loading: requestLoading }" :disabled="requestLoading" v-if="$checkPermission('view_subscription')">
          <p class="btn-text"><i style="margin-right: 5px;" class="fa-solid fa-file-excel"></i>Xuất Excel</p>
        </button>
        <!-- <button @click="addClick" class="add-new" v-if="$checkPermission('create_admission')">+ Thêm mới</button> -->
      </div>
    </div>

    <div class="table-section">
      <table>
        <thead>
          <tr>
            <th>STT</th>
            <th>Tên</th>
            <th>Số điện thoại</th>
            <th>Email</th>
            <th>Ngày gửi</th>
            <th>Ngày cập nhật</th>
            <th>Cập nhật bởi</th>
            <th>Hành động</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(ctt, i) in getSubData" :key="i">
            <td>{{ (currentPage - 1) * pageSize + i + 1 }}</td>
            <td>{{ ctt.name }}</td>
            <td>{{ ctt.phoneNum }}</td>
            <td>{{ ctt.email }}</td>
            <td>{{ formatDate(ctt.createdAt) }}</td>
            <td>{{ formatDate(ctt.updatedAt) }}</td>
            <td>{{ ctt.updatedBy }}</td>
            <td>
              <div class="action-holder">
                <button style="background-color: #0298cf;" @click="editClick(ctt)"
                  v-if="$checkPermission('edit_subscription')"><i class="fa-solid fa-pen-to-square"></i></button>
                <button style="background-color: #f80000;" @click="toggleAlert(ctt.id)"
                  v-if="$checkPermission('delete_subscription')"><i class="fa-solid fa-trash"></i></button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <div @click="changePage(currentPage - 1)" :disabled="currentPage === 1"><i class="fa-solid fa-angle-left"></i></div>
      <div @click="changePage(1)" v-if="currentPage !== 1">1</div>
      <div v-if="currentPage - 2 >= 1" style="cursor: auto;"><i class="fa-solid fa-ellipsis"></i></div>
      <div style="color: #0298cf; cursor: default; background: rgba(171, 171, 171, 0.2);">{{ currentPage }}</div>
      <div v-if="currentPage + 2 <= totalPages" style="cursor: auto;"><i class="fa-solid fa-ellipsis"></i></div>
      <div @click="changePage(totalPages)" v-if="currentPage !== totalPages">{{ totalPages }}</div>
      <div @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages"><i class="fa-solid fa-angle-right"></i></div>
    </div>
  </div>

  <!-- modal -->
  <base-modal :modalActive="modalActive" :modalTitle="modalTitle" @close="toggleModal">
    <div class="data-display">
      <div class="box"> <p>Tên<span style="color: red;">*</span></p></div>
      <input type="text" v-model="name"/>
    </div>

    <div class="data-display">
      <div class="box"> <p>Số điện thoại<span style="color: red;">*</span></p></div>
      <input type="number" v-model="phoneNum"/>
    </div>

    <div class="data-display">
      <div class="box"> <p>Email<span style="color: red;">*</span></p></div>
      <input type="text" v-model="email"/>
    </div>

    <div class="btn-container">
      <button :class="{ loading: requestLoading }" :disabled="requestLoading" v-if="id !== 0" @click="updateClick()">
        <p class="btn-text">Cập nhật</p>
      </button>
    </div>
  </base-modal>

  <alert-modal :modalActive="modalAlert" @close="toggleAlert(selectedId)"
    :requestLoading="requestLoading"
    @delete="deleteClick(selectedId)">
  </alert-modal>
</template>

<script>
export default {
  data () {
    return {
      fileUpload: '',
      isPreview: false,
      pageSize: 10,
      currentPage: 1,
      modalActive: false,
      modalAlert: false,
      modalPreview: false,
      modalTitle: '',
      filterTerm: '',
      appliedTerm: '',
      isValid: true,
      selectedId: 0,
      propertiesToCheck: ['name', 'phoneNum', 'email'],
      isUpdated: false,
      tempImage: '',
      hasCreatedData: false,
      changeLang: false,
      checkEn: false,
      loadEditData: false,
      originalUrl: '',
      msg: '',
      requestLoading: false,
      totalPages: 1,
      isLoading: false,
      // data
      id: 0,
      img: '',
      title: '',
      summary: '',
      description: '',
      hidden: true,
      url: '',
      subMenuId: 0,
      lang: 'vn',
      author: '',
      updatedAt: ''
    }
  },
  computed: {
    getSubData () {
      return this.$store.getters['sub/backendSubscriptions']
    }
  },
  watch: {
    lang (newLang) {
      if (newLang === 'en') {
        this.subMenuId = 34
      } else {
        this.subMenuId = 15
      }
    }
  },
  methods: {
    sendFilterTerm () {
      this.currentPage = 1
      this.appliedTerm = this.filterTerm
      this.getSubDetailData()
    },
    getCurrentDate () {
      const date = new Date()
      const year = date.getFullYear()
      const month = ('0' + (date.getMonth() + 1)).slice(-2)
      const day = ('0' + date.getDate()).slice(-2)
      return `${year}-${month}-${day}`
    },
    changePage (page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page
        this.getSubDetailData()
      }
    },
    reloadPageWithFilter () {
      this.currentPage = 1
    },
    toggleModal () {
      this.modalActive = !this.modalActive
    },
    toggleAlert (id) {
      this.selectedId = id
      this.modalAlert = !this.modalAlert
    },
    togglePreview (dcpt) {
      this.description = dcpt
      this.modalPreview = !this.modalPreview
    },
    formatDate (dateString) {
      if (!dateString) return null
      const date = new Date(dateString)
      return date.toLocaleDateString('en-GB')
    },
    validateVariable () {
      this.isValid = true
      this.propertiesToCheck.forEach(key => {
        if (this[key] === '' || this[key] === null) {
          this.isValid = false
        }
      })
    },
    async exportExcel () {
      this.requestLoading = true
      await this.$store.dispatch('sub/exportExcel', { filteredTerm: this.appliedTerm })
      this.requestLoading = false
    },
    async getSubDetailData () {
      this.isLoading = true
      this.totalPages = await this.$store.dispatch('sub/getSubscriptionByPageWithFilter', { filteredTerm: this.appliedTerm, pageNumber: this.currentPage })
      if (this.$store.getters['sub/backendSubscriptions'].length === 0) {
        if (this.currentPage > 1) {
          this.currentPage--
          this.totalPages = await this.$store.dispatch('sub/getSubscriptionByPageWithFilter', { filteredTerm: this.appliedTerm, pageNumber: this.currentPage })
        }
        if (this.totalPages < 1) this.totalPages = 1
      }
      this.isLoading = false
    },
    editClick (data) {
      this.hasCreatedData = false
      this.changeLang = true
      this.checkEn = false
      this.loadEditData = false
      this.originalUrl = data.url
      this.isValid = true
      this.isUpdated = true
      this.isPreview = false
      this.toggleModal()
      this.fileUpload = ''
      this.modalTitle = 'Chỉnh sửa subscription'
      this.id = data.id
      this.name = data.name
      this.phoneNum = data.phoneNum
      this.email = data.email
    },
    async updateClick () {
      this.requestLoading = true
      this.validateVariable()
      if (!this.isValid) {
        this.requestLoading = false
        this.$showError('Thiếu dữ liệu cần thiết')
        return
      }

      const updatedSubDetail = {
        id: this.id,
        name: this.name,
        phoneNum: this.phoneNum,
        email: this.email
      }

      try {
        await this.$store.dispatch('sub/updateSubscription', updatedSubDetail)

        this.requestLoading = false
        this.getSubDetailData()
        this.toggleModal()
      } catch (error) {
        this.requestLoading = false
        this.$showError(error)
      }
    },
    async deleteClick (id) {
      this.requestLoading = true
      await this.$store.dispatch('sub/deleteSubscription', id)
      this.requestLoading = false
      this.toggleAlert()
      this.getSubDetailData()
    }
  },
  async created () {
    await this.getSubDetailData()
  }
}
</script>
<style scoped>
  .table {
    width: 100%;
  }

  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background-color: rgb(240, 240, 240);
    flex-wrap: wrap;
  }

  .table-header p {
    color: #000;
  }

  button {
    outline: none;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    padding: 10px;
    color: #fff;
  }

  .add-new {
    padding: 10px 20px;
    color: #fff;
    background-color: #0298cf;
  }

  .table-header input {
    padding: 10px 20px;
    outline: none;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    border: 1px solid #0298cf;
    color: #0298cf;
  }

  ::placeholder {
    color: #0298cf;
  }

  /* table-header end */

  /* sua */
  .table-section {
    min-height: 590px;
  }

  table {
    width: 100%;
    table-layout: auto;
    min-width: 1000px;
    border-collapse: collapse;
  }

  thead th {
    position: sticky;
    top: 0;
    background-color: #0298cf;
    color: #fff;
    font-size: 15px;
    height: 50px;
  }

  th,td {
    border-bottom: 1px solid #dddddd;
    padding: 10px 20px;
    text-align: center;
    border-right: 1px solid #dddddd;
    border-left: 1px solid #dddddd;
  }

  td {
    text-align: left;
  }

  td img {
    height: 60px;
    width: 60px;
    object-fit: cover;
    border-radius: 15px;
    border: 3px solid #ced0d2;
  }

  tr:hover td {
    background-color: #cfe2ff;
  }

  .action-holder {
    display: flex;
    justify-content: space-around;
  }

  .action-holder button{
    margin: 0 5px;
    width: 35px;
  }

  ::-webkit-scrollbar{
    height: 5px;
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3)
  }

  ::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3)
  }

  tr:nth-child(even) {background-color: #ececec }

  th:nth-child(1), td:nth-child(1) {
    text-align: center;
    width: 60px;
  }

  /* th:nth-child(7), td:nth-child(7) {
    text-align: center;
    width: 120px;
  } */

  th:nth-child(6), td:nth-child(6), td:nth-child(5), td:nth-child(7) {
    text-align: center;
    width: 150px;
  }

  th:nth-child(8), td:nth-child(8) {
    text-align: center;
    padding: 10px 7px;
    width: 80px;
  }

  /* table end */

  .pagination {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    padding: 20px 20px;
  }

  .pagination div{
    padding: 10px;
    border: 1px solid #d5d0d0;
    height: 40px;
    width: 40px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #0298cf;
    color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.75);
    margin: 0 5px;
    cursor: pointer;
  }

  /* modal */

  .data-display {
    display: flex;
    align-items: center;
    margin-bottom: 30px;/* Sua */
    /* border: 2px solid #000; */
  }

  .data-display .box {
    width: 120px;
  }

  .box p {
    font-size: 15px;
  }

  .data-display input {
    height: 40px;
    width: 100%;
    border-radius: 6px;
    font-size: 17px;
    border: 1px solid #d9d9d9;
    padding: 0px 10px;
  }

  .data-display select {
    height: 40px;
    width: 100%;
    border-radius: 6px;
    font-size: 17px;
    border: 1px solid #d9d9d9;
    padding: 0px 7px;
  }

  #items {
    justify-content: space-between;
  }

  .data-display-s {
    display: flex;
    align-items: center;
  }

   .data-display-s select{
    margin-left: 27px;
  }

  .outsite > .data-display {
    display: block;
  }

  .outsite textarea {
    margin-top: 5px;
    height: 55px;
    width: 100%;
    border-radius: 6px;
    font-size: 17px;
    border: 1px solid #d9d9d9;
    padding: 5px;
  }

  .btn-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .btn-container button {
    position: relative;
    padding: 12px 30px;
    color: #fff;
    background-color: #0298cf;
    overflow: hidden;
  }

  .loading .btn-text {
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease;
  }

  .loading::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    pointer-events: none;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 3px solid transparent;
    border-top-color: white;
    border-right-color: white;
    animation: loading 1s ease infinite;
  }

  @keyframes loading {
    0% {
      transform: rotate(0turn);
    }
    100% {
      transform: rotate(1turn);
    }
  }

  .site-box {
    display: flex;
  }

  .first-site {
    flex: 1;
  }

  .second-site {
    width: 270px;
    padding-left: 45px;
  }

  .errors {
    font-weight: bold;
    color: red;
  }

  .ql-editor{
    height: 100%;
  }

  .detail {
    margin-bottom: 40px;
  }

  .detail .title {
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 10px;
  }

  .date-container {
    display: flex;
  }

  #icon {
    width: 16px;
    height: 16px;
  }

  .img-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .detail .date {
    color: #ababab;
    font-size: 14px;
    margin-left: 5px;
  }

  .detail .content {
    margin-top: 40px;
  }

  .publish-text {
    color: rgb(65, 225, 65);
    font-weight: 700;
  }

  .draft-text {
    color: rgb(226, 191, 49);
    font-weight: 700;
  }

  .excel-btn {
    position: relative;
    padding: 10px 20px;
    background-color: #008000;
  }

  .excel-btn p{
    color: #fff;
  }
</style>
